
import { getCouponInfo } from "./recurly.functions";

export const cardNumberStyle = ()=>{return ({
    inputType: 'mobileSelect',
    format: true,
    style: {
        fontFamily: "Nunito",
        fontSize: "0.875em",
        fontColor: "#373737",
        fontSmoothing: "antialiased",

        placeholder: { 
            content: 'Card number',
            color: "#AFAFAF"
        },
        invalid: {
            fontColor: 'red'
        }
    }
})};
export const cardMonthStyle = ()=>{return ({
    inputType: 'select',
    format: true,
    style: {
        fontFamily: "Nunito",
        fontSize: "0.875em",
        fontColor: "#373737",
        fontSmoothing: "antialiased",
        placeholder: {
            content: 'Month',
            color: "#AFAFAF"
        },
        invalid: {
            fontColor: 'red'
        }
    }
})};
export const cardYearStyle = ()=>{return ({
    inputType: 'select',
    format: true,
    style: {
        fontFamily: "Nunito",
        fontSize: "0.875em",
        fontColor: "#373737",
        fontSmoothing: "antialiased",
        placeholder: {
            content: 'Year',
            color: "#AFAFAF"
        },
        invalid: {
            fontColor: 'red'
        }
    }
})};
export const cardCvvStyle = ()=>{return ({
    inputType: 'mobileSelect',
    format: true,
    style: {
        fontFamily: "Nunito",
        fontSize: "0.875em",
        fontColor: "#373737",
        fontSmoothing: "antialiased",
        placeholder: {
            content: 'Security Code (CVV)',
            color: "#AFAFAF"
        },
        invalid: {
            fontColor: 'red'
        }
    }
})};

export const planTextSelector = (plan_code_from_url, gift, promo=null) => {
    let text;
    if (plan_code_from_url.includes("1mo")) text = "<ul><li>One-time purchase</li><li>6 exclusive full-size products</li><li>Wedding planning help included</li></ul>";
    else if (plan_code_from_url.includes("otb")) text = "<ul><li>15 exclusive full-size products</li><li>Premium keepsake box in a dust bag</li><li>Wedding planning help included</li></ul>";
    else {
        if(promo === "mtm50off") text = "<ul><li>$21 first box, renews $41.99 per box</li>"
        else if(promo === "mtm25off") text = "<ul><li>$31.49 first box, renews $41.99 per box</li>"
        else if(promo === "mtm30off") text = "<ul><li>$29 first box, renews $41.99 per box</li>"
        else text = "<ul><li><div id='box-price' class='text blurred' style='display: inline;'>-----</div> per box</li>";
        text += "<li>5-7 full-size products per box up to $150 in value</li>"
        if(gift){
            var regex = /\d+/g;
            var number = plan_code_from_url.match(regex);
            if(number[0] === "1") number = "1st";
            else if(number[0] === "2") number = "2nd";
            else if(number[0] === "3") number = "3rd";
            else number= number[0] + "th";
            text += `<li>Automatically stops after the ${number} box<div id="popup-inside" style="cursor: pointer;">i</div></li>`    
        }else {
            text += `<li>Automatically stops after the last theme<div id="popup-inside" style="cursor: pointer;">i</div></li>`;        
        }
        text += "<li>Pause or cancel anytime</li></ul>"
        if(plan_code_from_url.includes("prepaid")) text.replace("<ul><li><div id='box-price' class='text blurred' style='display: inline;'>-----</div> per box", "Pay once");
    }
    return text;
  }

  export const planNameSelector = (plan_code_from_url) => {
    let text;
    if (plan_code_from_url.includes("1mo")) text = "“Let’s Plan This” Themed Box";
    else if (plan_code_from_url.includes("otb")) text = "The Ultimate Bride Box";
    else if (plan_code_from_url.includes("mo-a") ) text = "EVERY 2 WEEKS PLAN";
    else if (plan_code_from_url.includes("mo-s") ) text = "MONTHLY PLAN";
    else if (plan_code_from_url.includes("mo-e") ) text = "EVERY 2 MONTHS PLAN";
    else if (plan_code_from_url.includes("mo-q") ) text = "EVERY 3 MONTHS PLAN";
    return text;
  }

  export const errorTextSelector = (error_obj) => {
    let text = error_obj.toString();
    if(text.includes("billing address does not match")){
        text = 'The billing address does not match. Please click "+ Enter new billing info" and enter details that match your credit card account.';
    }
    return text;
  }
  export const promoTextSelector = async (givenPromoCode) =>{
    let promoCode = givenPromoCode.toLowerCase();
    try{
        let couponInfo = await getCouponInfo(promoCode)
        if(couponInfo.success){
            return `Promo: ${couponInfo.coupon_name.trim()}`;
        }else {
            return `Promo: ${promoCode.toUpperCase()}`;
        }
    } catch(error) {
        return `Promo: ${promoCode.toUpperCase()}`;
    }
  }

